import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

//firebase
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private router : Router, private afAuth : AngularFireAuth) {

   }

   logout(){
     this.afAuth.signOut();
     this.router.navigate(['']); 
   }

   isLoggedIn(){
    //console.log(this.afAuth.currentUser);
  }
}
